// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".calc-block__control[data-v-4df8ac92]{border:1px solid #d3d3d3;border-radius:15px;padding:15px;display:flex;flex-direction:column;grid-gap:20px;gap:20px}.calc-controls__btn[data-v-4df8ac92]{margin-top:30px;width:100%}@media(max-width:660px){.calc-block__control[data-v-4df8ac92]{border:none;border-radius:0;border-radius:initial}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
